import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'getLocalized',
  pure: false, // Required to update when language changes
})
export class GetLocalizedPipe implements PipeTransform {
  constructor(private translationService: TranslateService) {}

  transform(translations?: Record<string, string> | null): string {
    if (!translations) return '';

    const current =
      this.translationService.currentLang ||
      this.translationService.defaultLang ||
      this.translationService.getBrowserCultureLang() ||
      'en-US';

    const pick = (lang: string) =>
      translations[lang] ??
      Object.keys(translations).find((key) =>
        key.toLowerCase().startsWith(lang.split('-')[0].toLowerCase())
      )
        ? translations[
            Object.keys(translations).find((key) =>
              key.toLowerCase().startsWith(lang.split('-')[0].toLowerCase())
            ) as string
          ]
        : undefined;

    return (
      pick(current) ||
      (this.translationService.defaultLang
        ? pick(this.translationService.defaultLang)
        : undefined) ||
      Object.values(translations)[0] ||
      ''
    );
  }
}
